// eslint-disable-next-line import/prefer-default-export
export const errorMessage = {
  UNKNOWN_400: '알 수 없는 에러가 발생했어요. 다시 시도해주세요.',
  SERVER_500: '서버에 접속할 수 없어요. 다시 시도해주세요.',
  TIMEOUT: '응답 시간을 초과했어요. 다시 시도해주세요.',
};
